import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function ForgotPassword() {
    const { t } = useLang();
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
            setDone(true);
        } catch {
            // Endpoint sempre 200 — fallback comunque success
            setDone(true);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="forgot-page" className="min-h-[80vh] max-w-md mx-auto px-5 py-20">
            <p className="text-xs tracking-[0.3em] uppercase text-abnormal-acid font-bold mb-4">{t("auth.forgotEyebrow")}</p>
            <h1 className="font-display text-5xl uppercase leading-none">{t("auth.forgotTitle")}</h1>
            <p className="text-zinc-400 mt-4 leading-relaxed">{t("auth.forgotSub")}</p>

            {done ? (
                <div data-testid="forgot-success" className="mt-10 border border-abnormal-acid/40 bg-abnormal-acid/5 p-6">
                    <p className="flex items-start gap-3 text-zinc-200">
                        <Mail className="text-abnormal-acid mt-0.5" size={18} />
                        <span>{t("auth.forgotSent")}</span>
                    </p>
                </div>
            ) : (
                <form onSubmit={submit} className="mt-10 space-y-4" data-testid="forgot-form">
                    <div>
                        <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold">{t("auth.email")}</label>
                        <input
                            data-testid="forgot-email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 w-full bg-abnormal-charcoal border border-white/10 focus:border-abnormal-acid outline-none px-4 py-3"
                        />
                    </div>
                    <button
                        data-testid="forgot-submit"
                        type="submit"
                        disabled={busy || !email}
                        className="w-full bg-abnormal-acid text-black uppercase tracking-wider font-bold py-3 hover:bg-abnormal-paper hover:text-black transition-colors disabled:opacity-60"
                    >
                        {busy ? t("auth.loginBusy") : t("auth.forgotBtn")}
                    </button>
                </form>
            )}

            <p className="text-sm text-zinc-500 mt-6">
                <Link to="/login" className="text-abnormal-acid uppercase tracking-wider font-bold">← {t("auth.backToLogin")}</Link>
            </p>
        </div>
    );
}
